module.exports = __webpack_public_path__ + "assets/img/lightbox.cc1adcc9.svg";